import { sanitizePermissions } from "@/constants/permissions";

export default {
  computed: {
    // Single UI-side permission check. Returns a real boolean — it used to
    // return `undefined` when `permissions` was missing.
    hasPermission() {
      return (permission) => {
        const user = this.$store.getters["adminModule/getUser"];
        if (!user) return false;
        return sanitizePermissions(user.permissions).includes(permission);
      };
    },
  },
};
